/** Premium ID card design tokens (2×3 portrait PVC ratio @ 300 DPI). */
export const ID_CARD_DPI = 300;
export const DESIGN_SCALE = ID_CARD_DPI / 96;

export const ID_CARD_DESIGN_IDS = ['saffron', 'navy', 'emerald'];

const SHARED = {
  textDark: '#0F172A',
  textMuted: '#334155',
  grayBorder: '#E2E8F0',
  graySoft: '#F8FAFC',
  white: '#FFFFFF',
  fontStack: "'Poppins', 'Inter', 'Montserrat', Arial, sans-serif",
  googleFonts: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@500;600;700;800&display=swap',
};

export const ID_CARD_DESIGNS = {
  saffron: {
    id: 'saffron',
    label: 'Saffron Classic',
    swatch: '#FF6B00',
    primary: '#F25C05',
    primaryBright: '#FF6B00',
    primaryDark: '#E65100',
    primaryLight: '#FF8A3D',
    accent: '#E65100',
    gradient: 'linear-gradient(135deg, #FF6B00 0%, #F25C05 45%, #E65100 100%)',
    headerText: '#FFFFFF',
    ringShadow: 'rgba(242,92,5,0.35)',
  },
  navy: {
    id: 'navy',
    label: 'Navy Professional',
    swatch: '#1E3A8A',
    primary: '#1E3A8A',
    primaryBright: '#2563EB',
    primaryDark: '#1E40AF',
    primaryLight: '#3B82F6',
    accent: '#1D4ED8',
    gradient: 'linear-gradient(135deg, #2563EB 0%, #1E3A8A 45%, #1E40AF 100%)',
    headerText: '#FFFFFF',
    ringShadow: 'rgba(30,58,138,0.35)',
  },
  emerald: {
    id: 'emerald',
    label: 'Emerald Modern',
    swatch: '#059669',
    primary: '#059669',
    primaryBright: '#10B981',
    primaryDark: '#047857',
    primaryLight: '#34D399',
    accent: '#047857',
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 45%, #047857 100%)',
    headerText: '#FFFFFF',
    ringShadow: 'rgba(5,150,105,0.35)',
  },
};

/** @deprecated use getDesignTheme */
export const ID_CARD_THEME = {
  saffron: ID_CARD_DESIGNS.saffron.primary,
  saffronBright: ID_CARD_DESIGNS.saffron.primaryBright,
  saffronDark: ID_CARD_DESIGNS.saffron.primaryDark,
  saffronLight: ID_CARD_DESIGNS.saffron.primaryLight,
  navy: SHARED.textDark,
  navyMuted: SHARED.textMuted,
  grayBorder: SHARED.grayBorder,
  graySoft: SHARED.graySoft,
  white: SHARED.white,
  gradient: ID_CARD_DESIGNS.saffron.gradient,
  fontStack: SHARED.fontStack,
  googleFonts: SHARED.googleFonts,
};

export function getDesignTheme(design = 'saffron') {
  const d = ID_CARD_DESIGNS[design] || ID_CARD_DESIGNS.saffron;
  return {
    ...SHARED,
    ...d,
    saffron: d.primary,
    saffronBright: d.primaryBright,
    saffronDark: d.primaryDark,
    saffronLight: d.primaryLight,
    navy: SHARED.textDark,
    navyMuted: SHARED.textMuted,
    gradient: d.gradient,
    white: SHARED.white,
  };
}

export const ID_CARD_PORTRAIT = {
  widthIn: 2,
  heightIn: 3,
  widthPx: 2 * ID_CARD_DPI,
  heightPx: 3 * ID_CARD_DPI,
  label: 'Portrait (2″ × 3″)',
};

export const ID_CARD_LANDSCAPE = {
  widthIn: 3,
  heightIn: 2,
  widthPx: 3 * ID_CARD_DPI,
  heightPx: 2 * ID_CARD_DPI,
  label: 'Landscape (3″ × 2″)',
};

/** Scale a 96-DPI design pixel value to current render DPI. */
export function designPx(n) {
  return n * DESIGN_SCALE;
}
